import {Service} from './index'

/**
 * 注册 获取验证码
 * @export
 * @param {*} data
 * @return {*} 
 */
export function reg_getCode(data) {
  return Service({
    url: '/amall_tools/aliyun/aliyunSMS',
    method:"post",
    params: data
  })
}
/**
 * 获取验证码
 * @export
 * @param {*} data 0 用户登录  1商户成员添加  2商户注册 3商户提现 4绑定银行卡  5成员忘记密码 6纯积分兑换商品 7服务商注册 8商户支付工程订单;工程订单预付款支付
 * @return {*} 
 */
 export function getCode(data) {
  return Service({
    url: '/amall_tools/aliyun/aliyunSMS',
    method:"post",
    params: data
  })
}
// 图片上传
export function upload_image(data) {
  return Service({
    url: '/amall_tools/aliyun/putImages',
    method:"post",
    data: data
  })
}
// 上传文件
export function upload_file(data) {
  return Service({
    url: '/amall_tools/aliyun/putFile',
    method:"post",
    data: data
  })
}
// 校验手机号
export function existMobile(data) {
  return Service({
    url: '/bbm_user/user/verifyUserExist',
    method:"post",
    params: data
  })
}
// APP_PC - [文字识别]识别身份证图片信息
export function discernIdentityCard(data) {
  return Service({
    url: '/bbm_user/user/discernIdentityCard',
    method:"post",
    params: data
  })
}
// APP_PC - [文字识别]识别营业执照图片信息
export function businessLicense(data) {
  return Service({
    url: '/bbm_user/user/businessLicense',
    method:"post",
    params: data
  })
}
// APP_PC - TL虚拟账户获取短信验证码
export function smsAssctnCdGet(data) {
  return Service({
    url: '/bbm_user/tluser/smsAssctnCdGet',
    method:"post",
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/service/tools.js